export const CUSTOMER_TRANSACTIONS_REQUEST = 'CUSTOMER_TRANSACTIONS_REQUEST';
export const CUSTOMER_TRANSACTIONS_REQUEST_SUCCESS = 'CUSTOMER_TRANSACTIONS_REQUEST_SUCCESS';
export const CUSTOMER_TRANSACTIONS_REQUEST_ERROR = 'CUSTOMER_TRANSACTIONS_REQUEST_ERROR';

export const CUSTOMER_TRANSACTION_UPDATE = 'CUSTOMER_TRANSACTION_UPDATE';
export const CUSTOMER_TRANSACTION_UPDATE_SUCCESS = 'CUSTOMER_TRANSACTION_UPDATE_SUCCESS';
export const CUSTOMER_TRANSACTION_UPDATE_ERROR = 'CUSTOMER_TRANSACTION_UPDATE_ERROR';

export const CUSTOMER_TRANSACTION_CAPITRON_FETCH = 'CUSTOMER_TRANSACTION_CAPITRON_FETCH';
export const CUSTOMER_TRANSACTION_CAPITRON_FETCH_SUCCESS =
  'CUSTOMER_TRANSACTION_CAPITRON_FETCH_SUCCESS';
export const CUSTOMER_TRANSACTION_CAPITRON_FETCH_ERROR =
  'CUSTOMER_TRANSACTION_CAPITRON_FETCH_ERROR';

export const MAIN_JOURNAL_REQUEST = 'MAIN_JOURNAL_REQUEST';
export const MAIN_JOURNAL_REQUEST_SUCCESS = 'MAIN_JOURNAL_REQUEST_SUCCESS';
export const MAIN_JOURNAL_REQUEST_ERROR = 'MAIN_JOURNAL_REQUEST_ERROR';
